import React, {useState} from "react";
import BookingItemAdmin from "../BookingItemAdmin/BookingItemAdmin";
import PropTypes from "prop-types";
import BookingItemPreview from "../BookingItemPreview/BookingItemPreview";
import FilterDropdown from "../FilterDropdown/FilterDropdown";
import FilterCalendar from "../FilterCalendar/FilterCalendar";
import Loading from "../Loading/Loading";

const BookingsContainer = ({
                             bookings,
                             dates,
                             setDates,
                             isLoading,
                             handleCalendarChange,
                             callbackConfirm = null,
                             showForAdmin = false
                           }) => {

  const DEFAULT_FILTERS = [
    {key: "receiving", label: "Inkomend", type: "direction", enabled: true},
    {key: "requesting", label: "Uitgaand", type: "direction", enabled: true},

    {key: "statusRequested", label: "Aangevraagd", type: "status", enabled: true},
    {key: "statusAccepted", label: "Geaccepteerd", type: "status", enabled: true},
    {key: "statusPayAfter", label: "Pay after", type: "status", enabled: true},
    {key: "statusPaid", label: "Betaald & Bevestigd", type: "status", enabled: true},
    {key: "statusRejected", label: "Afgewezen", type: "status", enabled: false},
    {key: "statusCanceled", label: "Geannuleerd", type: "status", enabled: false},
    {key: "statusCompleted", label: "Afgerond", type: "status", enabled: false},
  ];

  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const toggleFilter = (key) => {
    setFilters(prev =>
      prev.map(f => (f.key === key ? {...f, enabled: !f.enabled} : f))
    );
  };

  const isEnabled = (key) => !!filters.find(f => f.key === key)?.enabled;

  const statusKeyMap = {
    requested: "statusRequested",
    accepted: "statusAccepted",
    "pay-after": "statusPayAfter",
    paid: "statusPaid",
    rejected: "statusRejected",
    canceled: "statusCanceled",
    completed: "statusCompleted",
  };

  const isFiltered = (booking) => {
    if (booking.direction === "receiving" && !isEnabled("receiving")) return true;
    if (booking.direction === "requesting" && !isEnabled("requesting")) return true;

    const statusKey = statusKeyMap[booking.status];
    return !!(statusKey && !isEnabled(statusKey));
  };

  return (
    <div className="component-bookings-container">
      <div className="filters">
        <FilterCalendar
          label="Datum filter"
          dates={dates}
          setDates={setDates}
          isLoading={isLoading}
          handleCalendarChange={handleCalendarChange}
        />
        <FilterDropdown
          label="Status filter"
          filters={filters.filter(f => f.type === "status")}
          handleFilterSwitch={toggleFilter}
        />
        <FilterDropdown
          label="Richting filter"
          filters={filters.filter(f => f.type === "direction")}
          handleFilterSwitch={toggleFilter}
        />
      </div>
      <div className="bookings">
        {isLoading
          ? <Loading/>
          : <>
            {bookings && Array.isArray(bookings) && bookings.length > 0 ? (
              bookings.map((booking, i) =>
                  !isFiltered(booking) && (
                    <div key={i}>
                      {showForAdmin ? (
                        <BookingItemAdmin
                          callbackConfirm={callbackConfirm}
                          booking={booking}
                          showForAdmin={showForAdmin}
                        />
                      ) : (
                        <BookingItemPreview booking={booking}/>
                      )}
                    </div>
                  )
              )
            ) : (
              <>Nog geen Boekingen</>
            )}
          </>
        }
      </div>
    </div>
  );
};

BookingsContainer.propTypes = {
  bookings: PropTypes.array.isRequired,
  callbackConfirm: PropTypes.func,
  showForAdmin: PropTypes.bool,
};

export default BookingsContainer;
